import "../../main.js";
import Alpine from "../../plugins/alpine";

import Schema from "async-validator";

const descriptor = {
  name: {
    type: "string",
    required: true,
  },
  email: [{
    type: "string",
    required: true,
    
  }, 
  {
    type: "string",
    message: "Please enter a valid email address",
    pattern:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  }
],
  message: {
    type: "string",
    required: true,
  },
};
const validator = new Schema(descriptor);

const submit = form => validatorFields(form,  () => {
  // success callback
})

const validatorFields = (form, success) => {
  const { name, email, message } = form;
  validator
    .validate({ name, email, message })
    .then(() => {
      success?.({ name, email, message });
      return true;
    })
    .catch(({ errors, fields }) => {
      form.errors = errors;
      form.fields = fields;
      return false;
    });
}

Alpine.data("submit", submit);
Alpine.data("errors", null);
Alpine.data("fields", null);
Alpine.data("validatorFields", validatorFields);

Alpine.start();
